"use client"

import { useState } from "react"
import { useRouter } from "next/navigation"
import { ArrowRight, Sparkles, Loader2 } from "lucide-react"
import { Button } from "@/components/ui/button"
import posthog from "posthog-js"

export function UpgradeBanner({ className = "", trialJustUsed = false }) {
  const router = useRouter()
  const [loading, setLoading] = useState(false)

  return (
    <div className={`flex flex-col gap-3 rounded-lg border border-primary/20 bg-primary/5 px-4 py-3 sm:flex-row sm:items-center ${className}`}>
      <Sparkles className="hidden h-4 w-4 shrink-0 text-primary sm:block" />
      <p className="flex-1 text-sm text-muted-foreground">
        {trialJustUsed
          ? "Your free trial is complete. Upgrade to keep getting AI feedback and live interviews."
          : "Improve faster with live interviews, personalized feedback, and more."}
      </p>
      <Button
        size="sm"
        variant="outline"
        className="shrink-0"
        disabled={loading}
        style={{ minWidth: loading ? undefined : "fit-content" }}
        onClick={() => {
          posthog.capture("upgrade_banner_clicked", { trial_just_used: trialJustUsed })
          setLoading(true)
          router.push("/#pricing")
        }}
      >
        {loading ? (
          <>
            <Loader2 className="h-3 w-3 animate-spin" />
            Loading...
          </>
        ) : (
          <>
            View Plans
            <ArrowRight className="ml-1.5 h-3 w-3" />
          </>
        )}
      </Button>
    </div>
  )
}
